var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSgwsDndSmallDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M4.783 4.226a4.5 4.5 0 0 1 3.582-3.171A4.846 4.846 0 0 1 12.7 2.612a4.345 4.345 0 0 1 3.6-.239 3.381 3.381 0 0 1 1.938 2.4s2.909-.407 3.626 1.94-1.861 5.685-5.541 3.75q-.362 1.935-3 2.62-2.745.446-4.045-1.274-.916 1.72-3.808 1.274a2.234 2.234 0 0 1-1.926-2.336Q.548 9.684 1.1 6.8t3.683-2.574z",
    transform: "translate(8.792 12.605)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c8c8c8",
    strokeWidth: "0.6px",
    d: "M7.7-.011a5.264 5.264 0 0 1 4.64 1.527 4.637 4.637 0 0 1 3.846-.21A3.636 3.636 0 0 1 18.3 3.66a5.1 5.1 0 0 1 2.517.7 3.236 3.236 0 0 1 1.397 1.87 3.672 3.672 0 0 1-.149 2.339 4.637 4.637 0 0 1-1.517 2.014 4.064 4.064 0 0 1-2.165.826 4.433 4.433 0 0 1-2.118-.394 2.726 2.726 0 0 1-.937 1.429 5.881 5.881 0 0 1-2.246 1.056 5.294 5.294 0 0 1-2.5-.017 3.726 3.726 0 0 1-1.717-1.039 3.026 3.026 0 0 1-1.588 1.009 6.315 6.315 0 0 1-2.669.051 2.961 2.961 0 0 1-1.652-.98 2.735 2.735 0 0 1-.55-1.657A4.257 4.257 0 0 1 .188 9.159a3.963 3.963 0 0 1-.383-2.818A3.92 3.92 0 0 1 1.14 3.86a4.033 4.033 0 0 1 2.63-.76A5.013 5.013 0 0 1 7.7-.011z",
    transform: "translate(9.262 12.995)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgwsDndSmallDisabled);
export default __webpack_public_path__ + "static/media/sgws-dnd-small-disabled.fcb394ea32543625aab5d0d8d2f81faa.svg";
export { ForwardRef as ReactComponent };